export enum ChannelState {
	DISCONNECTED = 'disconnected',
	RECONNECTING = 'reconnecting',
	CHANNEL_OPEN = 'channel_open',
	CHANNEL_CLOSED = 'channel_closed',
	ERROR = 'error',
}
